// extracted by mini-css-extract-plugin
export default {"contain":"Services_contain__y8IAR","cont":"Services_cont__GIFHa","heading":"Services_heading__5oPUG","subHeading":"Services_subHeading__-U6eJ"};